import React from 'react';
import { AssortmentDetails, AssortmentRecord, AssortmentStoreOptionCounts, Material } from 'buyplan-common';
import AssortmentDetailCheckbox from './AssortmentDetailCheckbox';

interface Props {
    clusterId: string;
    assortmentRecords: AssortmentDetails[];
    storeOptionCount: AssortmentStoreOptionCounts;
    material: Material;
    removeAssortment(assortmentRecord: AssortmentRecord, clusterId: string): Promise<void>;
    addToAssortment(assortmentRecord: AssortmentRecord, clusterId: string): Promise<void>;
    assortAllLoading: boolean;
    isDisabled: boolean;
}

function AssortmentStore({
    clusterId,
    assortmentRecords,
    storeOptionCount,
    material,
    addToAssortment,
    removeAssortment,
    assortAllLoading,
    isDisabled,
}: Props) {
    const record = assortmentRecords.find(
        (rec) =>
            rec.clusterId === clusterId &&
            rec.storeId === storeOptionCount.storeId &&
            rec.materialCode === material.materialCode
    );

    const handleChange = record ? removeAssortment : addToAssortment;

    return (
        <AssortmentDetailCheckbox
            clusterId={clusterId}
            assortAllLoading={assortAllLoading}
            key={`${storeOptionCount.number}_${material.materialCode}`}
            storeOptionCount={storeOptionCount}
            material={material}
            record={record}
            onChange={handleChange}
            isDisabled={isDisabled}
        />
    );
}

export default AssortmentStore;
